import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

import { useUrlFilters } from './_hooks/loadFiltersFromUrl'

const FilterWrapper = ({ children }) => {
  const initialFilter = useUrlFilters()

  return (
    <FilterHandler
      tempStorageNamespace="serviceOrders"
      initialState={{ ...initialFilter, fixedFilterFields: ['statusNames'] }}
    >
      {children}
    </FilterHandler>
  )
}

export default FilterWrapper
